<template>
  <base-card>
    <v-card-text>
      <div class="d-flex flex-column align-center justify-center text-center py-6">
        <h3 class="mb-8">Generación Masiva de NC a partir de Facturas Electrónicas</h3>

        <v-select
          v-model="selectedCompany"
          :items="filteredCompanies"
          dense
          item-text="displayText"
          label="Selecciona una compañía"
          prepend-inner-icon="mdi-domain"
          return-object
          solo
          @change="fetchToken"
        >
          <template v-slot:prepend-item>
            <v-list-item>
              <v-list-item-content>
                <v-text-field
                  v-model="search"
                  class="mx-4"
                  dense
                  hide-details
                  placeholder="Buscar compañía"
                  prepend-inner-icon="mdi-magnify"
                />
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"/>
          </template>
        </v-select>

        <div v-if="loadingToken">
          <em>Obteniendo token...</em>
        </div>
      </div>

      <div
        v-if="token"
        class="d-flex flex-column align-center justify-center text-center py-6"
      >
        <v-row style="width: 100%; max-width: 900px;">
          <v-col cols="12">
            <v-combobox
              v-model="consecutivosFE"
              :hint="`${consecutivosFE.length} factura(s) agregada(s)`"
              chips
              clearable
              deletable-chips
              label="Facturas FE"
              multiple
              persistent-hint
              @paste="handlePaste"
            />
          </v-col>


          <v-col cols="12" md="4">
            <v-text-field
              v-model="serieNC"
              label="Serie Nota Crédito"
              outlined
            />
          </v-col>

          <v-col cols="12" md="2">
            <v-text-field
              v-model="ncInicio"
              label="NC Inicial"
              outlined
              type="number"
            />
          </v-col>
          <v-col cols="12" md="6">

            <v-text-field
              v-model="resolutionNumber"
              label="Número de Resolución"
              outlined
            />
          </v-col>
        </v-row>

        <v-row style="width: 100%; max-width: 900px;">

          <v-col cols="12" md="6">


            <v-text-field
              v-model="resolutionRange"
              label="Rango Resolución"
              placeholder="1 - 10000"
              :hint="resolutionRankPreview"
              persistent-hint
              outlined
            />
          </v-col>

        </v-row>
        <v-row style="width: 100%; max-width: 900px;">

          <v-col cols="12" md="4"></v-col>

          <v-btn
            :disabled="loading"
            class="ma-2"
            color="grey"
            @click="clearFields"
          >
            Limpiar
          </v-btn>

          <v-btn
            :disabled="loading"
            :loading="loading"
            class="ma-2"
            style="background-color: rgb(204 33 40); color: white !important;"
            @click="generarNCs"
          >
            Generar NCs
          </v-btn>


        </v-row>

        <v-progress-linear
          v-if="loading"
          class="my-4"
          color="primary"
          indeterminate
        />
        <v-alert
          v-if="alerta.mostrar"
          :type="alerta.tipo"
          class="my-4"
          dismissible
          style="white-space: pre-line;"
          @input="alerta.mostrar = false"
        >
          {{ alerta.mensaje }}
        </v-alert>

        <v-dialog
          v-model="showModal"
          max-width="1400px"
          persistent
        >
          <v-card>
            <v-card-title>
              Resultado generación NCs

              <v-spacer/>


              <v-btn
                class="mr-2"
                color="primary"
                small
                @click="copyResults"
              >
                <v-icon left>mdi-content-copy</v-icon>
                Copiar resultados
              </v-btn>

              <v-btn
                icon
                @click="showModal = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-simple-table dense>
                <thead>
                <tr>
                  <th>Factura FE</th>
                  <th>Nota Crédito</th>
                  <th>CUFE FE</th>
                  <th>CUFE NC</th>
                  <th>Diferencia IVA</th>
                  <th>Diferencia Total</th>
                  <th>Estado</th>
                  <th>Mensaje</th>
                </tr>
                </thead>

                <tbody>
                <tr
                  v-for="(item, index) in resultados"
                  :key="index"
                >
                  <td>{{ item.Factura }}</td>

                  <td>{{ item.NotaCredito }}</td>

                  <td>
                    {{ item.CufeFE ? item.CufeFE.substring(0, 12) + '...' : '' }}

                    <v-tooltip v-if="item.CufeFE" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          small
                          @click="copy(item.CufeFE )"
                        >
                          mdi-content-copy
                        </v-icon>
                      </template>

                      <span>Copiar CUFE</span>
                    </v-tooltip>
                  </td>

                  <td>
                    {{ item.CufeNC ? item.CufeNC.substring(0, 12) + '...' : '' }}

                    <v-tooltip v-if="item.CufeNC" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          small
                          @click="copy(item.CufeNC)"
                        >
                          mdi-content-copy
                        </v-icon>
                      </template>

                      <span>Copiar CUFE</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <v-chip
                      :color="item.DiferenciaIVA > 0 ? 'orange' : item.DiferenciaIVA < 0 ? 'red' : 'green'"
                      dark
                      small
                    >
                      {{ formatMoney(item.DiferenciaIVA) }}
                    </v-chip>
                  </td>

                  <td>
                    <v-chip
                      :color="item.DiferenciaTotal > 0 ? 'orange' : item.DiferenciaTotal < 0 ? 'red' : 'green'"
                      dark
                      small
                    >
                      {{ formatMoney(item.DiferenciaTotal) }}
                    </v-chip>
                  </td>
                  <td>
                    <v-chip
                      :color="item.Estado === 'OK' ? 'green' : 'red'"
                      small
                      text-color="white"
                    >

                      {{ item.Estado }}
                    </v-chip>
                  </td>

                  <td>{{ item.Mensaje }}</td>
                </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </v-card-text>
  </base-card>
</template>

<script>
import axios from 'axios'
import {environment} from '@/data/environment'

export default {
  data() {
    return {
      companias: [],
      selectedCompany: null,
      token: null,
      search: '',
      resolutionRange: '',
      consecutivosFE: [],
      serieNC: '',
      ncInicio: '',
      resolutionNumber: '',
      resolutionRank: '',
      resultados: [],
      showModal: false,

      loading: false,
      loadingToken: false,

      alerta: {
        mostrar: false,
        mensaje: '',
        tipo: 'error'
      }
    }
  },

  computed: {
    filteredCompanies() {
      const query = this.search.toLowerCase()

      return this.companias.filter(c =>
        c.displayText.toLowerCase().includes(query)
      )
    },
    resolutionRankPreview() {

      if (!this.resolutionRange) {
        return 'Se generará automáticamente.';
      }

      const partes = this.resolutionRange
        .split('-')
        .map(x => x.trim());

      if (partes.length !== 2) {
        return 'Formato esperado: 1 - 10000';
      }

      return `${this.serieNC} (Desde ${partes[0]} Hasta ${partes[1]})`;
    },

  },

  mounted() {
    this.fetchCompanies()
  },

  watch: {
    consecutivosFE(nuevoValor) {

      if (nuevoValor.length > 50) {

        this.alerta = {
          mostrar: true,
          tipo: 'warning',
          mensaje: 'Solo se permiten máximo 50 facturas por lote.'
        };

        this.consecutivosFE = nuevoValor.slice(0, 50);
      }
    }
  },
  methods: {

    buildResolutionRank() {

      if (!this.resolutionRange) {
        return '';
      }

      const partes = this.resolutionRange
        .split('-')
        .map(x => x.trim());

      if (partes.length !== 2) {
        return '';
      }

      return `${this.serieNC} (Desde ${partes[0]} Hasta ${partes[1]})`;
    },
    formatMoney(value) {
      return Number(value).toLocaleString("es-CO", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    copyResults() {
      const encabezado = [
        "Factura FE",
        "Nota Crédito",
        "CUFE FE",
        "CUFE NC",
        "Diferencia IVA",
        "Diferencia Total",
        "Estado",
        "Mensaje"
      ].join("\t");

      const filas = this.resultados.map(item => [
        item.Factura || "",
        item.NotaCredito || "",
        item.CufeFE || "",
        item.CufeNC || "",
        item.DiferenciaIVA || 0,
        item.DiferenciaTotal || 0,
        item.Estado || "",
        item.Mensaje || ""
      ].join("\t"));

      navigator.clipboard.writeText(
        [encabezado, ...filas].join("\n")
      );

      this.generateAlertCopy();
    },
    async copy(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.generateAlertCopy();
      } catch (e) {
        console.error(e);
      }
    },

    async fetchCompanies() {
      try {
        const res = await axios.get(
          environment.HIOPOSWEBSERVICES + '/api/getClients'
        )

        this.companias = res.data.Mensaje.map(compania => ({
          ...compania,
          displayText:
            `${compania.IdCompania} - ${compania.NombreCompania}`
        }))
      } catch (e) {
        console.error(e)
      }
    },
    handlePaste(event) {

      event.preventDefault();

      const texto = event.clipboardData.getData('text');

      const nuevasFacturas = texto
        .split(/\r?\n|,|;/)
        .map(x => x.trim())
        .filter(x => x);

      const facturas = [...new Set([
        ...this.consecutivosFE,
        ...nuevasFacturas
      ])];

      if (facturas.length > 50) {

        this.alerta = {
          mostrar: true,
          tipo: 'warning',
          mensaje: 'Solo se permiten máximo 50 facturas por lote.'
        };

        setTimeout(() => {
          this.alerta = {
            mostrar: false,
            mensaje: ""
          };
        }, 3000);
        this.consecutivosFE = facturas.slice(0, 50);

        return;
      }

      this.consecutivosFE = facturas;

    },
    async fetchToken() {
      if (!this.selectedCompany) {
        return
      }

      this.token = null
      this.loadingToken = true

      try {
        const formData = new FormData()

        formData.append(
          'TokenEnterprise',
          this.selectedCompany.TokenEnterprise
        )

        formData.append(
          'TokenPassword',
          this.selectedCompany.TokenPassword
        )

        const response = await axios.post(
          environment.HIOPOSWEBSERVICES + '/api/login',
          formData
        )

        this.token = response.data.token
      } catch (e) {
        console.error(e)
      } finally {
        this.loadingToken = false
      }
    },

    clearFields() {
      this.selectedCompany = null
      this.token = null
      this.search = ''

      this.consecutivosFE =
        this.serieNC = ''
      this.ncInicio = ''
      this.resolutionNumber = ''
      this.resolutionRange = ''

      this.resultados = []
      this.showModal = false
    },

    async generarNCs() {


      console.log(this.selectedCompany);

      console.log(this.token);

      console.log(this.consecutivosFE);

      const invoices = this.consecutivosFE
        .map(x => x.trim())
        .filter(x => x !== '')

      if (invoices.length === 0) {
        this.alerta = {
          mostrar: true,
          tipo: 'warning',
          mensaje: 'Debe ingresar al menos una factura.'
        }
        setTimeout(() => {
          this.alerta = {
            mostrar: false,
            mensaje: ""
          };
        }, 3000);
        return
      }

      this.loading = true
      let user = JSON.parse(atob(localStorage.getItem('uid'))).user;
      const resolutionRank = this.buildResolutionRank();


      try {
        const payload = {
          IdCompania: this.selectedCompany.IdCompania,
          SerieNC: this.serieNC,
          NCInicio: this.ncInicio,
          ResolutionNumber: this.resolutionNumber,
          ResolutionRank: resolutionRank,
          UsuarioProcesoMasivo: user,
          Facturas: invoices
        }

        const response = await axios.post(
          environment.HIOPOSWEBSERVICES +
          '/api/generarNotasCreditoMasivas',
          payload,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )

        this.resultados = response.data.resultados || []
        this.showModal = true
      }  catch (e) {

      console.error(e);

      let mensaje = 'Error generando las notas crédito.';

      if (e.response && e.response.data) {

        const data = e.response.data;


        if (data.Error && data.Consecutivos) {

          mensaje =
            data.Mensaje +
            '\n\n' +
            data.Consecutivos.map(c => `• ${c}`).join('\n');

        } else if (data.Mensaje) {

          mensaje = data.Mensaje;
        }
      }

      this.alerta = {
        mostrar: true,
        tipo: 'error',
        mensaje
      };

      setTimeout(() => {
        this.alerta = {
          mostrar: false,
          mensaje: ""
        };
      }, 6000);

    } finally {
      this.loading = false;
    }

    }
  }
}
</script>
